<!-- Changer d'adresse (PC-10, une feuille par édition) : la feuille s'ouvre
     sur l'adresse actuelle, une suggestion choisie s'enregistre. -->
<vw-toast-popup variant="full" [isOpen]="isOpen" [title]="'profile.addresses.edit-address.title' | translate" (close)="onClose()">
  <div class="flex flex-col gap-4 px-4 pb-8">
    <div class="flex flex-col gap-2">
      <span class="text-body-s text-vw-muted">{{ 'profile.garden-sheet.edit.label' | translate }}</span>
      <vw-location-input [(value)]="addressInput" (valueChange)="pickMissing = false" (suggestionSelected)="onSelectFeature($event)"
        [placeholder]="'onboarding.questions.address.input.placeholder'"></vw-location-input>
      @if (pickMissing) {
        <!-- Bouton jamais grisé (P4.3.1) : un toucher sans suggestion choisie dit ce qui manque. -->
        <p class="text-body-s text-vw-danger" role="alert" data-testid="address-pick-missing">
          {{ 'profile.garden-sheet.edit.pick' | translate }}
        </p>
      } @else {
        <p class="text-body-s text-vw-muted">{{ 'profile.garden-sheet.edit.help' | translate }}</p>
      }
    </div>
    @if (saveFailed) {
      <p class="text-body-s text-vw-danger" role="alert">{{ 'profile.garden-sheet.edit.error' | translate }}</p>
    }
    <vw-button look="primary" customClass="w-full" [label]="'profile.addresses.edit-address.button'"
      [loading]="isUpdatingAddress" (click)="onSaveAddress()" data-testid="address-save"></vw-button>
  </div>
</vw-toast-popup>
